<template>
  <div class="user-center__case-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
          >{{ nav.name }}</router-link
        >
      </template>
      <template #bt>
        <router-link tag="div" to="/my/case/create" class="bt-item">发布案例</router-link>
      </template>
    </SubPageHeader>
    <div class="case__main-body">
      <router-view :key="$route.fullpath" class="common-user-case-list-container"></router-view>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../_pageHeader.vue';

export default {
  components: {
    SubPageHeader,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '我的案例',
          url: '/my/cases',
        },
      ],
    };
  },
  watch: {
    $route: 'init',
  },
  created() {
    // console.log('dynamic index created');
  },
  methods: {
    init(val) {
      console.log(val);
      console.log('case index init');
    },
  },
};
</script>

<style></style>
